"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const client_1 = require("@apollo/client");
const MapmakerApi_1 = require("../../client/MapmakerApi");
function createFetchResources(client) {
    return (refs) => __awaiter(this, void 0, void 0, function* () {
        return {
            DESIGN: yield fetchDesigns(refs.DESIGN, client),
            FILE: yield fetchFiles(refs.FILE, client),
            OPENING_SUGGESTION: yield fetchOpeningSuggestions(refs.OPENING_SUGGESTION, client),
        };
    });
}
exports.default = createFetchResources;
/**
 * Fetch design resources
 */
(0, client_1.gql) `
  fragment RenderableDesign on MapmakerDesign {
    id
    businessId
    name
    width
    height
    regionType
    regionTypePlural
    regionCount
    features
  }
  query getRenderableDesign($designId: String!) {
    design: mapmakerDesign(id: $designId) {
      ...RenderableDesign
    }
  }
`;
function fetchDesigns(designIds, client) {
    return __awaiter(this, void 0, void 0, function* () {
        const designs = yield Promise.all(designIds.map(designId => fetchDesign(designId, client)));
        return designs.reduce((designMap, design) => (Object.assign(Object.assign({}, designMap), { [design.id]: design })), {});
    });
}
function fetchDesign(designId, client) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const result = yield client.query({
                query: MapmakerApi_1.GetRenderableDesignDocument,
                variables: {
                    designId,
                },
            });
            if (!result.data.design) {
                throw new Error(`Could not find design '${designId}'.`);
            }
            return result.data.design;
        }
        catch (e) {
            throw new Error(`Could not find design '${designId}'.`);
        }
    });
}
/**
 * Fetch file resources
 */
(0, client_1.gql) `
  fragment RenderableFile on MapmakerFile {
    id
    updatedAt
    name
    inputs
    design {
      ...RenderableDesign
    }
  }
  query getRenderableFile($fileId: String!) {
    file: mapmakerFile(id: $fileId) {
      ...RenderableFile
    }
  }
`;
function fetchFiles(fileIds, client) {
    return __awaiter(this, void 0, void 0, function* () {
        const files = yield Promise.all(fileIds.map(fileId => fetchFile(fileId, client)));
        return files.reduce((fileMap, file) => (Object.assign(Object.assign({}, fileMap), { [file.id]: file })), {});
    });
}
function fetchFile(fileId, client) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const result = yield client.query({
                query: MapmakerApi_1.GetRenderableFileDocument,
                variables: {
                    fileId,
                },
            });
            return result.data.file;
        }
        catch (e) {
            throw Error(`Could not find project ${fileId}.`);
        }
    });
}
/**
 * Fetch suggestion resources
 */
(0, client_1.gql) `
  fragment RenderableOpeningSuggestion on OpeningSuggestion {
    id
    fileId
    openingId
    input
  }
  query getRenderableOpeningSuggestion(
    $fileId: String!
    $openingId: String!
    $suggestionId: String!
  ) {
    suggestion: openingSuggestion(
      fileId: $fileId
      openingId: $openingId
      suggestionId: $suggestionId
    ) {
      ...RenderableOpeningSuggestion
    }
  }
`;
function fetchOpeningSuggestions(suggestionIds, client) {
    return __awaiter(this, void 0, void 0, function* () {
        const suggestions = yield Promise.all(suggestionIds.map(suggestionId => fetchOpeningSuggestion(suggestionId, client)));
        return suggestions.reduce((suggestionMap, suggestion) => (Object.assign(Object.assign({}, suggestionMap), { [[suggestion.fileId, suggestion.openingId, suggestion.id].join(":")]: suggestion })), {});
    });
}
function fetchOpeningSuggestion(suggestionIdBundle, client) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const [fileId, openingId, suggestionId] = suggestionIdBundle.split(":");
            const result = yield client.query({
                query: MapmakerApi_1.GetRenderableOpeningSuggestionDocument,
                variables: {
                    fileId,
                    openingId,
                    suggestionId,
                },
            });
            return result.data.suggestion;
        }
        catch (e) {
            throw Error(`Could not find opening suggestion ${suggestionIdBundle}.`);
        }
    });
}
//# sourceMappingURL=data:application/json;base64,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